import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Button, Typography } from "@material-ui/core";
import _ from "lodash";
export class AddModal extends React.Component {
    render() {
        const { qualAddModalInfo, unselectedQualifications } = this.props;
        let selectedQualification = Object.keys(unselectedQualifications).map(e => {
            if (qualAddModalInfo.qualInfo.qualID === unselectedQualifications[e].qualification_id)
                return unselectedQualifications[e];
            else return null;
        });
        selectedQualification = _.compact(selectedQualification);
        return (
            <div>
                <Modal isOpen={qualAddModalInfo.modalOpen}>
                    <ModalHeader>Add Qualification Info</ModalHeader>
                    <ModalBody>
                        <div
                            style={{
                                width: "100%"
                            }}
                        >
                            <Typography variant="body2">
                                Once a Qualification is Added to Required Qualifications You Will Be
                                Unable To Edit
                            </Typography>
                            <Typography variant="body2">
                                Are You Sure The Details Are Correct Before Adding?
                            </Typography>
                            <Typography variant="body2">
                                Title: <b>{qualAddModalInfo.qualInfo.qualTitle}</b>
                            </Typography>
                            <Typography variant="body2">
                                Expiry Date Required:{" "}
                                <b>
                                    {qualAddModalInfo.qualInfo.qualExpReq === true ? "Yes" : "No"}
                                </b>
                            </Typography>
                            <Typography variant="body2">
                                Image Required:{" "}
                                <b>
                                    {qualAddModalInfo.qualInfo.qualImgReq === true ? "Yes" : "No"}
                                </b>
                            </Typography>
                            <Typography variant="body2">
                                Verification Required:{" "}
                                <b>
                                    {qualAddModalInfo.qualInfo.qualVerReq === true ? "Yes" : "No"}
                                </b>
                            </Typography>
                            <Typography variant="body2">
                                Registration Number Required:{" "}
                                <b>
                                    {qualAddModalInfo.qualInfo.qualRegReq === true ? "Yes" : "No"}
                                </b>
                            </Typography>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div>
                            <Button
                                onClick={() => {
                                    this.props.addModalInfo(
                                        {
                                            qualID: "",
                                            qualTitle: false,
                                            qualExpReq: false,
                                            qualImgReq: false,
                                            qualRegReq: false,
                                            qualVerReq: false
                                        },
                                        false
                                    );
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.props.setQualificationToSelected(
                                        qualAddModalInfo.qualInfo.qualID
                                    );
                                    this.props.addModalInfo(
                                        {
                                            qualID: "",
                                            qualTitle: false,
                                            qualExpReq: false,
                                            qualImgReq: false,
                                            qualRegReq: false,
                                            qualVerReq: false
                                        },
                                        false
                                    );

                                    this.props.postRequiredQualification(selectedQualification[0]);
                                    this.addQualificationToAllUsers(selectedQualification[0]);
                                }}
                            >
                                Submit
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
    addQualificationToAllUsers(qual) {
        const { allUsers } = this.props;
        let qualForUser = {
            qualification_category: qual.qualification_category,
            qualification_desc: qual.qualification_desc,
            qualification_exp_date:
                qual.qualification_expiry_date_required === true ? "Req." : "N/A",
            qualification_id: qual.qualification_id,
            qualification_invalid_img: qual.qualification_invalid_img,
            qualification_prefix: qual.qualification_prefix,
            qualification_reg_num: qual.qualification_reg_number_required === true ? "" : "N/A",
            qualification_title: qual.qualification_title,
            qualification_valid_img: qual.qualification_valid_img,
            qualification_verified:
                qual.qualification_verification_required === true ? "No" : "N/A",
            qualification_img: qual.qualification_image_required === true ? "" : "N/A"
        };
        Object.keys(allUsers).map(e => {
            let profile = allUsers[e].profile;
            let userType = _.get(profile, "type") || "person";
            let deleted = _.get(profile, "deleted") || false;
            if (userType === "person" && !deleted) {
                if (profile.qualifications_per_user) {
                    profile.qualifications_per_user[qual.qualification_id] = qualForUser;
                } else {
                    profile.qualifications_per_user = {};
                    profile.qualifications_per_user[qual.qualification_id] = qualForUser;
                }

                this.props.postUpdatedUser(profile, e);
            }
            return true;
        });
    }
}
